import React, { Component } from 'react';
import PropTypes from 'prop-types';
import deepEqual from 'deep-equal';
import styles from './styles.scss';

const withPlaceholder = (InnerComponent, placeholderData) => {
  if (!placeholderData) {
    // eslint-disable-next-line no-console
    console.warn(`Missing argument: withPlaceholder(${InnerComponent.name}) \
      requires dummy props as it's second argument. Please check the default \
      export of ${InnerComponent.name}`);

    return InnerComponent;
  }

  class WithPlaceholder extends Component {
    shouldComponentUpdate(nextProps) {
      return !deepEqual(this.props, nextProps, { strict: true });
    }

    render() {
      const props = this.props.isPlaceholder
        ? {
            ...this.props,
            ...placeholderData,
            placeholderClass: styles.placeholder,
          }
        : this.props;

      return <InnerComponent {...props} />;
    }
  }

  WithPlaceholder.propTypes = {
    isPlaceholder: PropTypes.bool,
  };

  WithPlaceholder.defaultProps = {
    isPlaceholder: false,
  };

  return WithPlaceholder;
};

export default withPlaceholder;
